<template lang="pug">
	.player-card(
		:class="'is-size-' + size"
	)
		b-tag(
			v-if="size === 'tiny'"
			closable
			@close="$emit('close', player)"
		)
			span.player-icon(v-if="icon")
				img(:src="icon", width="64", height="64")
			span {{ player.number }}
			span {{ player.name }}
		article.card-wrapper(
			v-else
		)
			.player-card-media(v-if="player.portrait || backupCrest")
				figure.image
					img(v-if="player.portrait", :src="getMediaThumbnailURL(player.portrait)")
					img(v-else :src="backupCrest" style="padding: 0.5em")
			.player-card-content
				span.player-icon(v-if="icon")
					img(:src="icon", width="64", height="64")
				span.player-number {{ player.number }}
				span.player-name {{ player.name }}
			button.button.is-small(v-if="closable", @click="$emit('close', player)")
				b-icon(icon="times")
</template>

<script>
import mediaMixin from '../mixins/mediaMixin'
export default {
	mixins: [ mediaMixin ],
	props: {
		player: Object,
		closable: Boolean,
		size: {
			type: String,
			normal: 'default'
		},
		icon: String,
		backupCrest: String
	}
}
</script>

<style lang="scss" scoped>
	@import '@/assets/scss/bulma-variables.scss';
	.player-card {
		display: inline-flex;

		// Card appearance
		article.card-wrapper {
			position: relative;
			background: white;
			box-shadow: 0 2px 3px rgba(10,10,10,.1), 0 0 0 1px rgba(10,10,10,.1);
			display: inline-flex;
		}

		.player-card-media {
			figure {
				min-width: 70px;
				height: 100px;
				background: $light;
				margin: 0;
				img {
					background: rgba($dark, 0.2);
					height: 100px;
					width: auto;
				}
			}
		}
		.player-card-content {
			padding: 0.2em 1em;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			.player-icon {
				position: absolute;
				top: 0.5em;
				right: 1em;
				img {
					width: 32px;
					height: 32px;
				}
			}
			.player-number {
				font-size: 1.8em;
				font-weight: bold;
				color: rgba($dark, 0.5);
			}
			.player-name {
				font-size: 1.2em;
				color: $dark;
			}
		}

		// Button
		button.button {
			display: none;
			position: absolute;
			top: 0;
			right: 0;
			color: $dark;
		}
		&:hover {
			button.button {
				display: block;
			}
		}

		// Small size
		&.is-size-small {
			.player-card-media {
				figure {
					min-width: 30px;
					height: 60px;
					img {
						height: 60px;
					}
				}
			}
			.player-card-content {
				padding: 0.1em 0.4em;
				.player-icon {
					top: 0.1em;
					right: 0.2em;
					img {
						width: 18px;
						height: 18px;
					}
				}
				.player-number {
					font-size: 1em;
				}
				.player-name {
					font-size: 0.8em;
				}
			}
		}
		&.is-size-tiny {
			.tag {
				img {
					width: 14px;
					height: 14px;
				}
				span:not(:last-child) {
					margin-right: 0.5em;
				}
			}
		}

		@media screen and (max-width: 768px) {
			.player-card-media {
				figure {
					min-width: 30px;
					height: 70px;
					img {
						height: 70px;
					}
				}
			}
			.player-card-content {
				padding: 0.1em 0.4em;
				.player-icon {
					top: 0.1em;
					right: 0.2em;
					img {
						width: 18px;
						height: 18px;
					}
				}
				.player-name {
					font-size: 0.8em;
				}
				.player-number {
					font-size: 1em;
				}
			}
		}
	}
</style>
